import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {DisplayOrgComponent} from "./display-org.component";
import {OrgSettingsModule} from "../org-settings/org-settings.module";
import {OrgUsersModule} from "../org-users/org-users.module";
import {TabsModule} from "ngx-bootstrap/tabs";
import {FormsModule} from "@angular/forms";
import { OrgReferenceModule } from '../org-reference-settings/org-reference-settings.module';


@NgModule({
  declarations: [DisplayOrgComponent],
  imports: [
    CommonModule,
    FormsModule,
    AlertMessageModule,
    OrgSettingsModule,
    OrgReferenceModule,
    OrgUsersModule,
    TabsModule.forRoot()
  ],
  exports: [DisplayOrgComponent]
})
export class DisplayOrgModule {
}
